module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "alert",
    staticClass: "erroralert alert alert-warning alert-dismissible fade"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.message))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4021f7ef", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4021f7ef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrorAlert.vue
// module id = 466
// module chunks = 1